// extracted by mini-css-extract-plugin
module.exports = {"PhotoTitleEditForm__submitBtn":"jo_a bhu_rm","PhotoTitleEditForm__cancelBtn":"jo_b bhu_rq bhu_rp"};